import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-document",
  "use": "icon-s-document-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-document\"><path d=\"M17 14V3.8c0-.994-.768-1.8-1.714-1.8H6.714C5.768 2 5 2.806 5 3.8v14.4c0 .994.768 1.8 1.714 1.8H11v-6zm-1 2h-3v3l.55-.55zm-3.565 6H6a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v12.435z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol